export default class LoadingButton extends HTMLButtonElement {

    // Available loading classes are dot-elastic, dot-pulse, dot-flashing, dot-collision, dot-revolution, dot-carousel, dot-typing, dot-windmill, dot-bricks, dot-streching, dot-falling 
    //  if this package is included
    //  See https://github.com/nzbin/three-dots

    constructor() {
        super();
    }

    connectedCallback() {
        this.addEventListener("click", this.handleClick);
    }

    disconnectedCallback() {
        this.removeEventListener("click", this.handleClick);
    }

    get defaultContent() {
        return this.dataset.defaultContent;
    }

    set defaultContent(value) {
        this.dataset.defaultContent = value;
    }

    get loadingText() {
        return this.dataset.loadingText;
    }

    set loadingText(value) {
        this.dataset.loadingText = value;
    }

    handleClick(event) {

        let btn = event.currentTarget;

        // If the forms needs-validation but doesn't validate, don't set loading class
        if (btn.form && btn.form.classList.contains("needs-validation") && !btn.form.checkValidity()) {
            return;
        }

        btn.classList.add("loading");

        // Save the button text to be able to restore it.
        btn.defaultContent = btn.innerHTML;
        btn.innerHTML = (btn.loadingText || btn.defaultContent) + this.getLoadingElement(btn.loadingClass);

        setTimeout(function () {
            btn.disabled = true;
        }, 1);

    }

    restoreButton(btn) {
        btn = btn || this;
        btn.classList.remove("loading");
        btn.disabled = false;
        btn.innerHTML = btn.defaultContent || btn.innerHTML.replace(btn.getLoadingElement(btn.loadingClass), "");
    }

    getLoadingElement(loadingClass) {
        loadingClass = loadingClass || "dot-elastic";
        return "<div class='loading-animation " + loadingClass + "'></div>";
    }

}

customElements.define('loading-button', LoadingButton, { extends: 'button' });